/**
 * Download PDF blob as a file
 * @param {Blob} blob - PDF blob data
 * @param {string} filename - Optional filename (defaults to timestamped name)
 */
export function downloadPDF(blob, filename) {
  // Create a temporary URL for the blob
  const url = window.URL.createObjectURL(blob);

  // Create a temporary anchor element
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || `investment_report_${Date.now()}.pdf`;

  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL
  window.URL.revokeObjectURL(url);
}
